import { useQuery } from "@tanstack/react-query";

import { internetRegistrationsApi } from "@/api";
import { QueryKey } from "@/query/Query";

/**
 * Every online registration still awaiting a duplicate decision. Feeds both the review list and the
 * sidebar badge, so the two can never disagree about how many are pending.
 */
export function useInternetRegistrationsQuery() {
  return useQuery({
    queryKey: [QueryKey.InternetRegistrations],
    queryFn: () => internetRegistrationsApi.getInternetRegistrations(),
  });
}
